export default __webpack_public_path__ + "static/media/advantageIcon2.17e78e5b.png";